interface KeyboardShortcutsModalProps {
  open: boolean
  onClose: () => void
  quickLayers: string[]
}

const SHORTCUTS = [
  { keys: ["1-9"], description: "Activer/desactiver un calque rapide" },
  { keys: ["L"], description: "Ouvrir/fermer le panneau calques" },
  { keys: ["/"], description: "Focus recherche adresse" },
  { keys: ["C"], description: "Focus recherche commune" },
  { keys: ["P"], description: "Focus recherche parcelle" },
  { keys: ["?"], description: "Afficher les raccourcis" },
  { keys: ["Esc"], description: "Fermer le panneau actif" },
]

export const KeyboardShortcutsModal = ({ open, onClose }: KeyboardShortcutsModalProps) => {
  if (!open) return null

  return (
    <>
      <div className="absolute inset-0 bg-black/30 z-50" onClick={onClose} />
      <div className="absolute inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
        <div
          className="bg-white rounded-lg shadow-xl w-full max-w-sm anim-scale-in"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-700">Raccourcis clavier</span>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg leading-none">
              &times;
            </button>
          </div>
          <div className="px-4 py-3 space-y-2">
            {SHORTCUTS.map((s, i) => (
              <div key={i} className="flex items-center justify-between">
                <span className="text-sm text-gray-600">{s.description}</span>
                <div className="flex gap-1">
                  {s.keys.map((k) => (
                    <kbd
                      key={k}
                      className="px-2 py-0.5 bg-gray-100 text-gray-700 text-sm font-mono rounded border border-gray-200"
                    >
                      {k}
                    </kbd>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="px-4 pb-3">
            <button
              onClick={() => {
                onClose()
                window.dispatchEvent(new Event("explorer-restart-tour"))
              }}
              className="w-full text-xs text-gray-400 hover:text-[#1E40AF] py-2 transition-colors flex items-center justify-center gap-1.5 rounded-lg hover:bg-gray-50"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              Relancer le guide
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
